import { useDispatch } from "react-redux";
import { useSignOut } from "react-auth-kit";
import { useCrudFieldError } from "@/components/tables/crudErrorContext";

export const useEntityRequestFailureHandler = (
  handleError?: (error: any) => void
) => {
  const dispatch = useDispatch();
  const signOut = useSignOut();
  const handleFieldError = useCrudFieldError(handleError);

  return (error: any) => {
    if (error === "logout") {
      dispatch({ type: "clear" });
      signOut();
    }
    handleFieldError(error);
  };
};
